module.exports = __webpack_public_path__ + "img/laminar-circle.f8ae847a.svg";